import React from "react";
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import Heading from "../../../RecommendGrant/Component/ViewEditSchedules/Components/Heading";
import InfoBlock from "../../../RecommendGrant/Component/ViewEditSchedules/Components/InfoBlock";
import { BoxDetailWrapper } from "../../../RecommendGrant/Component/ViewEditSchedules/style";
import { addressFormat } from "../../../RecommendGrant/utils";

const renderContactNumber = (isBorder, contactInfo) => {
  return (
    <BoxDetailWrapper border={isBorder} span={14} offset={2}>
      <InfoBlock
        border={isBorder}
        title="Contact Number"
        value={contactInfo.contactPhoneNumber}
      />
    </BoxDetailWrapper>
  );
};

const contactNameGenerator = ({ contactName, contactLastName }) => {
  return `${contactName} ${contactLastName}`;
};

export default function CharityDetailSummary({
  charityInfo = {},
  contactInfo = {},
}) {
  return (
    <Row>
      <Col xs={0} md={0} lg={24}>
        <Row>
          <Col span={8}>
            <Heading
              title={charityInfo.title}
              edit={charityInfo.edit}
              handleEdit={charityInfo.handleEdit}
              id="btnCharityInfoEdit1"
            />
          </Col>
        </Row>
        <Row type="flex">
          <BoxDetailWrapper border span={8}>
            <InfoBlock
              border
              title="Full charity name"
              value={charityInfo.charityName}
            />
          </BoxDetailWrapper>
          <BoxDetailWrapper border span={14} offset={2}>
            <InfoBlock
              border
              title="Contact Name"
              value={contactNameGenerator(contactInfo)}
            />
          </BoxDetailWrapper>
        </Row>
        <Row type="flex">
          <BoxDetailWrapper border span={8}>
            <InfoBlock
              border
              title="Address"
              value={addressFormat(charityInfo.charityAddress)}
            />
          </BoxDetailWrapper>
          {contactInfo.contactEmail ? (
            <BoxDetailWrapper border span={14} offset={2}>
              <InfoBlock
                border
                title="Contact Email"
                value={contactInfo.contactEmail}
              />
            </BoxDetailWrapper>
          ) : (
            renderContactNumber(true, contactInfo)
          )}
        </Row>
        <Row type="flex">
          <BoxDetailWrapper span={8}>
            <InfoBlock title="EIN" value={charityInfo.charityEin} />
          </BoxDetailWrapper>
          {contactInfo.contactPhoneNumber &&
            contactInfo.contactEmail &&
            renderContactNumber(false, contactInfo)}
        </Row>
      </Col>
      <Col md={24} xs={24} lg={0}>
        <Heading
          title={charityInfo.title}
          edit={charityInfo.edit}
          handleEdit={charityInfo.handleEdit}
          id="btnCharityInfoEdit2"
        />
        <BoxDetailWrapper border>
          <InfoBlock
            border
            title="Full Charity Name"
            value={charityInfo.charityName}
          />
        </BoxDetailWrapper>
        <BoxDetailWrapper border>
          <InfoBlock
            border
            title="Address"
            value={addressFormat(charityInfo.charityAddress)}
          />
        </BoxDetailWrapper>
        <BoxDetailWrapper border>
          <InfoBlock title="EIN" value={charityInfo.charityEin} />
        </BoxDetailWrapper>
        <BoxDetailWrapper border>
          <InfoBlock
            border
            title="Contact Name"
            value={contactNameGenerator(contactInfo)}
          />
        </BoxDetailWrapper>
        {contactInfo.contactEmail && (
          <BoxDetailWrapper border={contactInfo.contactEmail}>
            <InfoBlock
              border
              title="Contact Email"
              value={contactInfo.contactEmail}
            />
          </BoxDetailWrapper>
        )}
        {contactInfo.contactPhoneNumber && (
          <BoxDetailWrapper>
            <InfoBlock
              title="Contact Number"
              value={contactInfo.contactPhoneNumber}
            />
          </BoxDetailWrapper>
        )}
      </Col>
    </Row>
  );
}

CharityDetailSummary.propTypes = {
  charityInfo: PropTypes.object,
  contactInfo: PropTypes.object,
}
